module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "notification-overlay",
    class: {
      open: _vm.isDropdownOpened
    }
  }, [_c('div', {
    staticClass: "triangle"
  })]), _c('ul', {
    staticClass: "nav",
    class: _vm.navClasses
  }, [_c('li', [_c('router-link', {
    staticClass: "dropdown-toggle",
    attrs: {
      "to": "/chat",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/faces/ic_chat.svg")
    }
  }), _c('p', {
    staticClass: "hidden-lg hidden-md"
  }, [_vm._v("Chat")])])], 1), _c('li', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.closeDropdown),
      expression: "closeDropdown"
    }],
    staticClass: "dropdown",
    class: [(_vm.isDropdownOpened ? "open" : ""), _vm.iOS() ? "fix-safari" : ""]
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openDropdown($event)
      }
    }
  }, [_vm._m(0), (_vm.notify) ? _c('span', {
    staticClass: "notification"
  }) : _vm._e(), _c('p', {
    staticClass: "hidden-lg hidden-md"
  }, [_vm._v("Notifications")])]), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-notify"
  }, [_vm._l((_vm.lst5items), function(item, index) {
    return _c('li', {
      staticClass: "li-notify",
      style: (index === (_vm.lst5items.length - 1) ? 'border: none;' : ''),
      on: {
        "click": function($event) {
          return _vm.onNotifyItem(item.id)
        }
      }
    }, [_vm._m(1, true), _c('div', {
      staticClass: "content-notify",
      style: (item.status === 2 ? 'font-weight: bold;' : 'font-weight: normal;')
    }, [_vm._v(_vm._s(item.short_content)), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("moment")(item.created_at)))])])])
  }), _c('div', {
    staticClass: "lst-all"
  }, [_c('span', {
    on: {
      "click": _vm.onNotification
    }
  }, [_vm._v("Xem tất cả")])])], 2)]), _c('li', [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    },
    on: {
      "click": _vm.submitLogout
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/faces/ic_logout.svg")
    }
  }), _c('p', {
    staticClass: "hidden-lg hidden-md"
  }, [_vm._v("Sign out")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "material-icons"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/faces/ic_noti.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-avt"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/faces/ic_AvatarDefault.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e70de5c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation/navbar-right.vue
// module id = 1540
// module chunks = 0